import React from 'react';
import Element from '../element';

const TermsOfService = () => {
  return (
    <Element>
      <Element fontFamily="GTAR" fontSize="14px" marginTop="20px">
        Thorne Lab is focused on providing a comprehensive health assessment and
        is not a replacement for medical care. By making an appointment with
        Thorne Lab or proceeding with such services, you acknowledge that the
        assessment provided by Thorne Lab is (i) not medical advice; (ii) not
        intended to diagnose, treat, or prevent a disease; and (iii) not a
        substitute for a doctor’s examination and care.
      </Element>
      <Element
        fontFamily="GTAR"
        fontSize="14px"
        marginTop="20px"
        marginBottom="20px"
      >
        You further acknowledge that you are solely responsible for contacting
        your healthcare practitioner for attention to any specific health
        concerns that may be indicated by the information provided to you by
        Thorne Lab. You knowingly and voluntarily do hereby release, indemnify,
        acquit, waive, discharge, and hold harmless Thorne Lab for any action or
        failure to act on the information derived from the health assessment.
      </Element>
    </Element>
  );
};

export default TermsOfService;
